import { z } from 'zod';
import { idSchema, isoDateTimeSchema } from './common.js';
import { procurementUploadResponseSchema } from './procurement.js';
import { paginationMetaSchema, paginationQuerySchema } from './pagination.js';
export const vendorInvoiceOriginalUploadSchema = z.object({
    version: z.coerce.number().int().positive(),
    reason: z.string().trim().min(3).max(500).optional(),
});
export const vendorInvoiceOriginalSchema = z.object({
    id: idSchema,
    revision: z.number().int().positive(),
    source: z.enum(['MANUAL_UPLOAD', 'LEGACY_CAPTURE', 'ELECTRONIC_IMPORT']),
    attachmentId: idSchema.nullable(),
    electronicImportId: idSchema.nullable(),
    fileName: z.string(),
    mimeType: z.string(),
    fileSize: z.number().int().positive(),
    fileHash: z.string().regex(/^[a-f0-9]{64}$/u),
    xmlHash: z
        .string()
        .regex(/^[a-f0-9]{64}$/u)
        .nullable(),
    reason: z.string().nullable(),
    createdAt: isoDateTimeSchema,
    createdByName: z.string(),
});
export const vendorInvoiceOriginalHistoryQuerySchema = paginationQuerySchema.extend({
    sort: z.enum(['revision:desc', 'revision:asc']).default('revision:desc'),
});
export const vendorInvoiceOriginalHistorySchema = z.object({
    invoiceVersion: z.number().int().positive(),
    currentOriginalId: idSchema.nullable(),
    currentOriginal: vendorInvoiceOriginalSchema.nullable(),
    timezone: z.string().min(1),
    electronic: z.boolean(),
    legacyDocumentAvailable: z.boolean(),
    originals: z.array(vendorInvoiceOriginalSchema),
    meta: paginationMetaSchema,
});
export const vendorInvoiceOriginalEvidenceSchema = z.object({
    id: idSchema.nullable(),
    revision: z.number().int().positive().nullable(),
    source: z.enum([
        'MANUAL_UPLOAD',
        'LEGACY_CAPTURE',
        'ELECTRONIC_IMPORT',
        'LEGACY_FILE',
        'LEGACY_ELECTRONIC_IMPORT',
    ]),
    fileName: z.string(),
    fileHash: z.string().regex(/^[a-f0-9]{64}$/u),
    xmlHash: z
        .string()
        .regex(/^[a-f0-9]{64}$/u)
        .nullable(),
    attachmentId: idSchema.nullable(),
    electronicImportId: idSchema.nullable(),
});
export const vendorInvoiceOriginalUploadResponseSchema = procurementUploadResponseSchema.extend({
    originalId: idSchema,
    invoiceVersion: z.number().int().positive(),
});
//# sourceMappingURL=vendor-invoice-original.js.map